import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Intelligencepage from "./Intelligence";
import AppHeader from "components/Header/AppHeader";
import MDBox from "components/MDBox";
function Intelligence({ subcategoryToken }) {
  return (
    <DashboardLayout>
      <MDBox
        sx={{
          display: {
            xs: "block",
            sm: "block",
            md: "none",
          },
        }}
      >
        <AppHeader enablePadding={true} />
      </MDBox>
      <Intelligencepage subcategoryToken={subcategoryToken} />
    </DashboardLayout>
  );
}

export default Intelligence;
